module.exports = __webpack_public_path__ + "img/10018.4fb762a5.jpg";